import React from "react";
import Image from "../../components/image";
import DownloadSvg from "images/icons/fi-rr-download.inline.svg";
import ArrowRightIcon from "images/icons/arrow-right-icon.inline.svg";

const DownloadPack = ({
  packTitle,
  infoPackLabel,
  infoPackText,
  bgImage,
  fallbackImage,
  infoPackFile,
  containerClassNames = "",
  viewmoreLink = ""
}) => {
  return (
    <section
      className={`relative z-10 w-full bg-gray-lighten planet:bg-gray-dark ${containerClassNames}`}
    >
      <div className="w-11/12 md:w-5/6 py-9 md:pt-20 md:pb-48 md:px-7 mx-auto">
        <h1 className="w-3/4 md:w-full pl-2 md:pl-0 pb-6 md:pb-11 font-normal planet:font-light">
          {packTitle}
        </h1>
        <div className="md:flex gap-14 w-full">
          {(bgImage || fallbackImage) && (
            <Image
              imageAlt={infoPackLabel}
              image={bgImage}
              sourceUrl={fallbackImage}
              imageClass="object-cover object-center md:w-7/12 rounded-xs md:shadow-xl"
            />
          )}
          <div className="bg-white planet:bg-gray-darkest mt-6 md:mt-0 p-6 pb-10 md:py-9 md:px-12 md:w-5/12">
            <h2 className="pb-5 !font-body !font-light">{infoPackLabel}</h2>
            <h6
              className="pb-10 md:pb-5 planet:text-gray-generic"
              dangerouslySetInnerHTML={{ __html: infoPackText }}
            />

            <a
              className="group flex flex-row items-center justify-center px-2 py-2 w-full md:w-7/12 md:mt-auto
                              bg-white planet:bg-transparent hover:bg-black-lighter planet:hover:bg-white
                                border border-black-lighter hover:border-white planet:border-white planet:hover:border-white rounded-full planet:rounded-sm
                                text-sm text-black-lighter hover:text-white planet:text-white planet:hover:text-gray-darker"
              href={infoPackFile}
            >
              <p className="text-base font-bold pr-2">Download</p>
              <DownloadSvg className="w-4 fill-black-lighter planet:fill-white group-hover:fill-white planet:group-hover:fill-gray-darker" />
            </a>
          </div>
        </div>
        {viewmoreLink && (
          <div className="pt-8 md:pt-16">
            <button
              className="callback-button group flex justify-center items-center w-full md:w-auto py-2 px-16 mx-auto
                            border !border-red-light planet:!border-green-standard rounded-full planet:rounded-sm 
                          bg-red-light planet:bg-green-standard planet:hover:bg-white
                          text-black-lighter planet:text-gray-darker"
            >
              View more
              <ArrowRightIcon className="ml-2 stroke-black-lighter planet:stroke-gray-darker" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default DownloadPack;
